const metadata = {
  GLOBAL: {
    PAGE_TITLE: 'Clearing House'
  }
};

export default metadata;
